import React from "react";

import { Button, Divider, Modal } from "semantic-ui-react";

type ModApproveInviteSuccessProps = {
  name: string;
  open: boolean;
  onClose: () => void;
};

type Styles = Record<
  "checkmark" | "closeButton" | "container" | "icon" | "title",
  React.CSSProperties
>;

const styles: Styles = {
  checkmark: {
    fill: "none",
    height: "40px",
    stroke: "white",
    strokeWidth: "3",
    width: "40px",
  },
  closeButton: {
    backgroundColor: "#d1d5db",
    borderRadius: "8px",
    color: "#374151",
    margin: "1rem 0 0.5rem",
  },
  container: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    padding: "2rem",
    textAlign: "center",
  },
  icon: {
    alignItems: "center",
    backgroundColor: "var(--primary-theme-color)",
    borderRadius: "50%",
    display: "flex",
    height: "80px",
    justifyContent: "center",
    margin: "0 auto",
    width: "80px",
  },
  title: {
    color: "#1f2937",
    fontSize: "1.4rem",
    fontWeight: "600",
    margin: "-0.5rem 0 0.25rem",
    width: "100%",
  },
};

const ModApproveInviteSuccess = (props: ModApproveInviteSuccessProps) => {
  const handleCloseModal = (): void => {
    props.onClose();
  };

  return (
    <Modal open={props.open} size="small" closeOnDimmerClick onClose={handleCloseModal}>
      <div style={styles.container}>
        <h1 style={{ ...styles.title, textAlign: "left" }}>แจ้งเตือน</h1>

        <Divider style={{ margin: "1rem 0", width: "100%" }} />

        <div style={{ margin: "1rem 0 2rem" }}>
          <div style={styles.icon}>
            <svg style={styles.checkmark} viewBox="0 0 24 24">
              <path d="M20 6L9 17L4 12" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>

        <h1 style={styles.title}>
          อนุมัติคำขอของ {props.name}{" "}
          <span style={{ color: "var(--primary-theme-color)" }}>สำเร็จ</span>
        </h1>

        <div
          style={{ display: "flex", justifyContent: "center", marginTop: "1.5rem", width: "100%" }}
        >
          <Button style={styles.closeButton} onClick={handleCloseModal}>
            ปิดหน้าต่าง
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ModApproveInviteSuccess;
